import { Pipe, PipeTransform } from "@angular/core";

@Pipe({
  name: "invitationErrorTranslationPrefix",
})
export class InvitationErrorTranslationPrefixPipe implements PipeTransform {
  /**
   * Picks the translation key prefix for the invitation error state's title/description,
   * based on the specific reason the invitation could not be loaded/accepted.
   */
  transform(invitationExpired: boolean, alreadyMember: boolean): string {
    if (invitationExpired) {
      return "invitation.error.expired";
    }

    if (alreadyMember) {
      return "invitation.error.alreadyMember";
    }

    return "invitation.error";
  }
}
